const PrimaryTheme = '#825efb';

const Theme = {
  PrimaryColor: PrimaryTheme,
  PrimaryGrey: '#62707B',
  PrimaryDark: '#3D2B56',

  PrimaryBackground: '#F8F8F5',
  PrimaryGreen: '#59d973',
  PrimaryMint: '#95fd35',
  PrimaryRed: '#ea2a8a',
  PrimaryYellow: '#F2C02E',
  PrimaryOrange: '#EF7E23',
  PrimaryBlue: '#5BB1F2',
  SecondaryColor: '#be7efc',
  SecondaryGrey: '#00000041',
  TetiaryColor: '#ecdbfe',

  PrimaryBorderColor: '#D8D8E3',
  PrimaryFade: '#F5F5F7',
  PrimaryInputOutline: '#9D9DB7',
  PrimaryCellPad: '15px',

  // workflow colours
  DraftStep: '#62707B',
  RegistrationStep: '#F2C02E',
  KeepInViewStep: '#5FB2F0',
  InReviewStep: '#1654B1',
  ShortlistedStep: '#EF7E23',
  ConditionalOfferStep: '#56765D',
  AcceptedStep: '#5FD877',
  DeclinedStep: '#E8318A',
  InvitationStep: '#8B5CFF',
  FollowUpStep: '#FFB74D',
  RecommendedOneStep: '#FF8A65',
  RecommendedTwoStep: '#4DB6AC',
  RecommendedThreeStep: '#BA68C8',

  SideNavOpen: '240px',
  SideNavClose: '80px'
};

export default Theme;
